import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component:()=> import ('@/views/index')
    },
    {
      path: '/list/:portId',
      name: 'list',
      component:()=> import ('@/views/list')
    },
    {
      path: '/article/:articleId',
      name: 'article',
      component:()=> import ('@/views/article')
    }
  ],
  //滚动到顶部
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js